<div class="intl-tel-input-container">
    <ngx-intl-tel-input
        #telInput
        [cssClass]="cssClass"
        [preferredCountries]="preferredCountries"
        [enableAutoCountrySelect]="enableAutoCountrySelect"
        [enablePlaceholder]="enablePlaceholder"
        [searchCountryFlag]="searchCountryFlag"
        [selectFirstCountry]="selectFirstCountry"
        [maxLength]="maxLength"
        [phoneValidation]="phoneValidation"
        [separateDialCode]="separateDialCode"
        [formControl]="phone"
        [ngClass]="styleInput"></ngx-intl-tel-input>
    @if (phone.touched && phone.hasError('required')) {
    <div class="alert">
        <span apxIcon icon="info"></span>
        {{ 'PhoneRequired' | translate }}
    </div>
    } @if (phone.touched && phone.invalid && phone.value) {
    <div class="alert">
        <span apxIcon icon="info"></span>
        {{ 'InvalidNumber' | translate }}
    </div>
    }
</div>
